import React from "react";
import { Users, Eye, Film } from "lucide-react";

function formatNumber(n) {
  if (n == null) return "—";
  const num = Number(n);
  if (Number.isNaN(num)) return "—";
  if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(1)}M`;
  if (num >= 1_000) return `${(num / 1_000).toFixed(1)}K`;
  return num.toLocaleString();
}

const decoItems = [
  "POV",
  "★",
  "MUSIC",
  "★",
  "PUBG",
  "★",
  "eFootball",
  "★",
  "Call Of Duty",
  "★",
  "Mountain Trails",
  "★",
  "Night Drives",
  "★",
  "GTA 5",
  "★",
];

export default function StatsMarquee({ stats }) {
  const hasStats = !!stats && !stats.hidden_subscriber_count;

  const cards = hasStats
    ? [
        { label: "Subscribers", value: formatNumber(stats.subscriber_count), icon: Users },
        { label: "Total Views", value: formatNumber(stats.view_count), icon: Eye },
        { label: "Videos", value: formatNumber(stats.video_count), icon: Film },
      ]
    : null;

  return (
    <section
      data-testid="stats-marquee"
      className="relative bg-[#050505] border-y border-white/5 overflow-hidden"
    >
      {/* Real channel stats */}
      {cards && (
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12 md:py-16 grid grid-cols-3 gap-4 md:gap-12 border-b border-white/5">
          {cards.map((c) => {
            const Icon = c.icon;
            return (
              <div
                key={c.label}
                data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex flex-col items-start"
              >
                <div className="flex items-center gap-2 mb-3 text-[#C41E3A]">
                  <Icon className="w-4 h-4" />
                  <span className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-white/60">
                    {c.label}
                  </span>
                </div>
                <span className="font-display uppercase text-5xl md:text-7xl lg:text-8xl leading-none tracking-tight text-white">
                  {c.value}
                </span>
              </div>
            );
          })}
        </div>
      )}

      {/* Decorative marquee */}
      <div className="marquee-track py-6">
        {[...decoItems, ...decoItems, ...decoItems].map((t, i) => (
          <span
            key={i}
            className={`font-display text-4xl md:text-6xl tracking-wider mx-8 whitespace-nowrap ${
              t === "★" ? "text-[#C41E3A]" : "text-white/85"
            }`}
          >
            {t}
          </span>
        ))}
      </div>
    </section>
  );
}
